define('glu/grid/row/rowGroupModel',['require','../../model','../../util'],function(require) {
    'use strict';

    var Model = require('../../model'),
        util = require('../../util');

    return Model.extend({
        getGroupTitle: function() {
            var title = this.get('title'),
                groupTitle = title || (this.get('currentTitle') || this.get('currentValue'));

            if (util.isFunction(title)) {
                groupTitle = title(this.get('currentTitle') || this.get('currentValue'));
            }

            return groupTitle;
        }
    });
});

